/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Tc_MultiplierInputs */



/**
* | output |
* | --- |
* | "TC Multiplier" |
*
* @param {Dialogue_List_Export_Tc_MultiplierInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_tc_multiplier = /** @type {((inputs?: Dialogue_List_Export_Tc_MultiplierInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Tc_MultiplierInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Multiplicateur TC")
	if (locale === "de") return /** @type {LocalizedString} */ ("TC-Multiplikator")
	if (locale === "it") return /** @type {LocalizedString} */ ("Moltiplicatore TC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Множитель TC")
	if (locale === "es") return /** @type {LocalizedString} */ ("Multiplicador de TC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("TC乘数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("TC乗数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीसी गुणक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Multiplicador TC")
	return /** @type {LocalizedString} */ ("TC Multiplier")
});